//@vendor
const React = require('react');
const moment = require('moment');
const PropTypes = require('prop-types');

//@utilities
const { formatText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');

//@common
const OKSelect = require('components/commons/OKSelect/OKSelect');
const OKModal = require('components/commons/OKModal/OKModal');

// @constants
const {
    DATE_FORMAT_MONTH_YEAR,
    DATE_FORMAT_API,
    DATE_FILTER_NONE
} = require('constants/index');

class OpenYoungCardExpensesFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            monthSelected: this.props.immFilters.getIn(['date','selectedMonth']),
        };

        this.handleMonthChange = this.handleMonthChange.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.getLast6Months = this.getLast6Months.bind(this);
    }

    handleOnSubmit(event) {
        event.preventDefault();
        const { monthSelected } = this.state;
        const filters = {
            date: {
                selectedMonth: monthSelected
            }
        }
        this.props.onFilterSubmitClick(filters);
        this.props.onCloseClick();
    }

    handleMonthChange(value) {
        this.setState({
            monthSelected: value.value
        });
    }

    getLast6Months(){
        const last6MonthsArray = new Array(7)
            .join().split(',')
            .map(function(item, index){
                let option;
                if(index === 0) {
                    option = {
                        value: DATE_FILTER_NONE,
                        label: formatText('openYoungCardExpensesFilter-noComparisonText')
                    };
                } else {
                    const prevMonthDate = moment().subtract(index, 'months').startOf('month');
                    const monthYear = DateHelper.buildFormattedDate(prevMonthDate, DATE_FORMAT_MONTH_YEAR);
                    option = {
                        value: moment(prevMonthDate).format(DATE_FORMAT_API),
                        label: monthYear
                    };
                }
                return option;
            });

        return last6MonthsArray;
    }

    buildMonthFilter() {
        const last6Months = this.getLast6Months();
        return (
            <OKSelect
                name="card-chores-month-filter-dropdown"
                onChange={this.handleMonthChange}
                value={this.state.monthSelected}
                options={last6Months}
                searchable={false}
                label="openYoungCardExpensesFilter-monthsLabel"
            />
        );
    }

    render() {
        const { 
            isOpen, 
            onCloseClick 
        } = this.props;
        const monthFilter = this.buildMonthFilter();
        return (
            <OKModal
                content={monthFilter}
                isOpen={isOpen}
                footerType="navigation"
                onCloseCallback={onCloseClick}
                onPrimaryButtonClick={this.handleOnSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                title="openYoungCardExpensesFilter-heading"
            />
        );
    }
}

OpenYoungCardExpensesFilter.propTypes = {
    immFilters: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    onFilterSubmitClick: PropTypes.func.isRequired
};

module.exports = OpenYoungCardExpensesFilter;
